<template>
	<svg
		width="36"
		height="37"
		viewBox="0 0 36 37"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2420_54880)">
			<path
				d="M21 3.5H9C7.35 3.5 6 4.85 6 6.5V30.5C6 32.15 7.35 33.5 9 33.5H27C28.65 33.5 30 32.15 30 30.5V12.5L21 3.5ZM18 15.5C19.65 15.5 21 16.85 21 18.5C21 20.15 19.65 21.5 18 21.5C16.35 21.5 15 20.15 15 18.5C15 16.85 16.35 15.5 18 15.5ZM24 27.5H12V26.645C12 25.43 12.72 24.35 13.83 23.87C15.105 23.315 16.515 23 18 23C19.485 23 20.895 23.315 22.17 23.87C23.28 24.35 24 25.43 24 26.645V27.5Z"
				fill="#2A8176"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2420_54880">
				<rect
					width="36"
					height="36"
					fill="white"
					transform="translate(0 0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
</template>


